const isProd = process.env.NODE_ENV === "production";

// You can also control more granularly via a variable if needed
let ENABLE_LOGS = !isProd;

const logTag = "[LOG]";
const infoTag = "[INFO]";
const warnTag = "[WARN]";
const errorTag = "[ERROR]";

const logger = {
  enable: () => {
    ENABLE_LOGS = true;
  },
  disable: () => {
    ENABLE_LOGS = false;
  },
  log: (...args) => {
    if (ENABLE_LOGS) {
      console.log(logTag, ...args);
    }
  },
  info: (...args) => {
    if (ENABLE_LOGS) {
      console.info(infoTag, ...args);
    }
  },
  warn: (...args) => {
    if (ENABLE_LOGS) {
      console.warn(warnTag, ...args);
    }
  },
  error: (...args) => {
    if (ENABLE_LOGS) {
      console.error(errorTag, ...args);
    }
  },
};

export default logger;
